import React from 'react';

import CommonImage from '@/components/CommonImage';

const TaskDashboardView = () => {
	return (
		<div className="body-content pending-task-container bg-white">
			<div className="running-task-header d-flex align-items-center justify-content-between mb-3">
				<p className="semibold-14 gray_dark_02">Task configuration</p>
				<div className="task-action d-flex align-items-center">
					<div className="form-group size32 m-0 mr-1 search-filter filter-with-animation">
						<div className="with-icon right-icon hidden">
							<input type="text" placeholder="Search" value="" />
							<span className="right-icon">
								<CommonImage src="/icons/search.png" alt="" />
							</span>
						</div>
					</div>
					<div className="add-new-design">
						<button className="button text size32 px-0">
							<CommonImage src="/icons/add-round.svg" alt="add" />
							<span className="ml-1 gray_dark_02">Dashboard</span>
						</button>
					</div>
				</div>
			</div>
			<div className="running-task-body d-flex justify-content-between align-items-start">
				<div className="running-task-table">
					<table className="table with-border scroll-x-label">
						<thead>
							<tr>
								<th>Stage (26)</th>
								<th>SL</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td rowSpan={2}>Techpack creation</td>
								<td className="sl-column">1</td>
							</tr>
						</tbody>
					</table>
				</div>
				{/* right Section - Main Content */}
				<div className="pending-task-left-section flex-grow-1">
					<div className="pending-task-header bg-white d-flex align-items-center justify-content-between">
						<div className="pending-task-summary">
							<p className="semibold-14 gray_dark_01">
								Total pending:<span className="gray_dark_01 ml-1">24</span>
								<span className="gray_dark_02 ml-1 regular-14 weight-400">
									| Today completed:
									<span className="ml-1">12</span>
								</span>
							</p>
						</div>
						<div className="pending-task-refresh">
							<span className="regular-14 gray_dark_02 weight-400 d-flex align-items-center cursor-pointer">
								<span className="mr-2">Refresh</span>
								<CommonImage src="/icons/load.svg" width={16} height={16} alt="Refresh" />
							</span>
						</div>
					</div>
					{/* Task Categories Grid */}
					<div className="task-categories d-grid gap-4 grid-columns-3 scroll-y-label">
						{/* Sample development Card */}
						<div className="task-category-card shadow-2dp">
							<div
								className="task-category-header d-flex align-items-center justify-content-between mb-3 p-1"
								style={{ backgroundColor: '#EFF6FF' }}
							>
								<div className="d-flex align-items-center">
									<CommonImage src="/icons/pom/t-shirt.svg" className="mr-2" />
									<p className="regular-14 weight-600" style={{ color: '#1C398E' }}>
										Sample development
									</p>
								</div>
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
										>
											<CommonImage
												src="/icons/more_vertical.svg"
												alt="more_icon"
												width={24}
												height={24}
											/>
										</button>
										<ul className="dropdown-menu dropdown-menu-right shadow-lg">
											<li className="px-4 pb-3 pt-3">
												<a className="font-weight-normal text-black">Edit</a>
											</li>
											<li className="px-4 pb-3">
												<a className="font-weight-normal text-black">Delete</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="task-category-body">
								<ul className="task-list">
									<li className="regular-14 gray_dark_01 mb-2 cursor-none">
										Need your sample review <span className="gray_dark_01">(20)</span>
									</li>
									<li className="regular-14 gray_dark_01 mb-2">
										Send to buyer <span className="gray_dark_01">(45)</span>
									</li>
									<li className="regular-14 gray_dark_01">
										Buyer sample review <span className="gray_dark_01">(23)</span>
									</li>
								</ul>
							</div>
							<div className="view-more d-flex align-items-center cursor-pointer mt-2">
								<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
									View <span>4</span> more
								</p>
								<CommonImage
									className="arrow-icon"
									src="/icons/down-arrow-gray-dark-01.svg"
									width={20}
									height={20}
								/>
							</div>
						</div>
						{/* Sample development Card */}
						<div className="task-category-card shadow-2dp">
							<div
								className="task-category-header d-flex align-items-center justify-content-between mb-3 p-1"
								style={{ backgroundColor: '#EFF6FF' }}
							>
								<div className="d-flex align-items-center">
									<CommonImage src="/icons/pom/t-shirt.svg" className="mr-2" />
									<p className="regular-14 weight-600" style={{ color: '#1C398E' }}>
										Sample development
									</p>
								</div>
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
										>
											<CommonImage
												src="/icons/more_vertical.svg"
												alt="more_icon"
												width={24}
												height={24}
											/>
										</button>
										<ul className="dropdown-menu dropdown-menu-right shadow-lg">
											<li className="px-4 pb-3 pt-3">
												<a className="font-weight-normal text-black">Edit</a>
											</li>
											<li className="px-4 pb-3">
												<a className="font-weight-normal text-black">Delete</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="task-category-body">
								<ul className="task-list">
									<li className="regular-14 gray_dark_01 mb-2 cursor-none">
										Need your sample review <span className="gray_dark_01">(20)</span>
									</li>
									<li className="regular-14 gray_dark_01 mb-2">
										Send to buyer <span className="gray_dark_01">(45)</span>
									</li>
									<li className="regular-14 gray_dark_01">
										Buyer sample review <span className="gray_dark_01">(23)</span>
									</li>
								</ul>
							</div>
							<div className="view-more d-flex align-items-center cursor-pointer mt-2">
								<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
									View <span>4</span> more
								</p>
								<CommonImage
									className="arrow-icon"
									src="/icons/down-arrow-gray-dark-01.svg"
									width={20}
									height={20}
								/>
							</div>
						</div>
						{/* Sample development Card */}
						<div className="task-category-card shadow-2dp">
							<div
								className="task-category-header d-flex align-items-center justify-content-between mb-3 p-1"
								style={{ backgroundColor: '#EFF6FF' }}
							>
								<div className="d-flex align-items-center">
									<CommonImage src="/icons/pom/t-shirt.svg" className="mr-2" />
									<p className="regular-14 weight-600" style={{ color: '#1C398E' }}>
										Sample development
									</p>
								</div>
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
										>
											<CommonImage
												src="/icons/more_vertical.svg"
												alt="more_icon"
												width={24}
												height={24}
											/>
										</button>
										<ul className="dropdown-menu dropdown-menu-right shadow-lg">
											<li className="px-4 pb-3 pt-3">
												<a className="font-weight-normal text-black">Edit</a>
											</li>
											<li className="px-4 pb-3">
												<a className="font-weight-normal text-black">Delete</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="task-category-body">
								<ul className="task-list">
									<li className="regular-14 gray_dark_01 mb-2 cursor-none">
										Need your sample review <span className="gray_dark_01">(20)</span>
									</li>
									<li className="regular-14 gray_dark_01 mb-2">
										Send to buyer <span className="gray_dark_01">(45)</span>
									</li>
									<li className="regular-14 gray_dark_01">
										Buyer sample review <span className="gray_dark_01">(23)</span>
									</li>
								</ul>
							</div>
							<div className="view-more d-flex align-items-center cursor-pointer mt-2">
								<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
									View <span>4</span> more
								</p>
								<CommonImage
									className="arrow-icon"
									src="/icons/down-arrow-gray-dark-01.svg"
									width={20}
									height={20}
								/>
							</div>
						</div>
						{/* Sample development Card */}
						<div className="task-category-card shadow-2dp">
							<div
								className="task-category-header d-flex align-items-center justify-content-between mb-3 p-1"
								style={{ backgroundColor: '#EFF6FF' }}
							>
								<div className="d-flex align-items-center">
									<CommonImage src="/icons/pom/t-shirt.svg" className="mr-2" />
									<p className="regular-14 weight-600" style={{ color: '#1C398E' }}>
										Sample development
									</p>
								</div>
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
										>
											<CommonImage
												src="/icons/more_vertical.svg"
												alt="more_icon"
												width={24}
												height={24}
											/>
										</button>
										<ul className="dropdown-menu dropdown-menu-right shadow-lg">
											<li className="px-4 pb-3 pt-3">
												<a className="font-weight-normal text-black">Edit</a>
											</li>
											<li className="px-4 pb-3">
												<a className="font-weight-normal text-black">Delete</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="task-category-body">
								<ul className="task-list">
									<li className="regular-14 gray_dark_01 mb-2 cursor-none">
										Need your sample review <span className="gray_dark_01">(20)</span>
									</li>
									<li className="regular-14 gray_dark_01 mb-2">
										Send to buyer <span className="gray_dark_01">(45)</span>
									</li>
									<li className="regular-14 gray_dark_01">
										Buyer sample review <span className="gray_dark_01">(23)</span>
									</li>
								</ul>
							</div>
							<div className="view-more d-flex align-items-center cursor-pointer mt-2">
								<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
									View <span>4</span> more
								</p>
								<CommonImage
									className="arrow-icon"
									src="/icons/down-arrow-gray-dark-01.svg"
									width={20}
									height={20}
								/>
							</div>
						</div>
						{/* Sample development Card */}
						<div className="task-category-card shadow-2dp">
							<div
								className="task-category-header d-flex align-items-center justify-content-between mb-3 p-1"
								style={{ backgroundColor: '#EFF6FF' }}
							>
								<div className="d-flex align-items-center">
									<CommonImage src="/icons/pom/t-shirt.svg" className="mr-2" />
									<p className="regular-14 weight-600" style={{ color: '#1C398E' }}>
										Sample development
									</p>
								</div>
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
										>
											<CommonImage
												src="/icons/more_vertical.svg"
												alt="more_icon"
												width={24}
												height={24}
											/>
										</button>
										<ul className="dropdown-menu dropdown-menu-right shadow-lg">
											<li className="px-4 pb-3 pt-3">
												<a className="font-weight-normal text-black">Edit</a>
											</li>
											<li className="px-4 pb-3">
												<a className="font-weight-normal text-black">Delete</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="task-category-body">
								<ul className="task-list">
									<li className="regular-14 gray_dark_01 mb-2 cursor-none">
										Need your sample review <span className="gray_dark_01">(20)</span>
									</li>
									<li className="regular-14 gray_dark_01 mb-2">
										Send to buyer <span className="gray_dark_01">(45)</span>
									</li>
									<li className="regular-14 gray_dark_01">
										Buyer sample review <span className="gray_dark_01">(23)</span>
									</li>
								</ul>
							</div>
							<div className="view-more d-flex align-items-center cursor-pointer mt-2">
								<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
									View <span>4</span> more
								</p>
								<CommonImage
									className="arrow-icon"
									src="/icons/down-arrow-gray-dark-01.svg"
									width={20}
									height={20}
								/>
							</div>
						</div>
						{/* Sample development Card */}
						<div className="task-category-card shadow-2dp">
							<div
								className="task-category-header d-flex align-items-center justify-content-between mb-3 p-1"
								style={{ backgroundColor: '#EFF6FF' }}
							>
								<div className="d-flex align-items-center">
									<CommonImage src="/icons/pom/t-shirt.svg" className="mr-2" />
									<p className="regular-14 weight-600" style={{ color: '#1C398E' }}>
										Sample development
									</p>
								</div>
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
										>
											<CommonImage
												src="/icons/more_vertical.svg"
												alt="more_icon"
												width={24}
												height={24}
											/>
										</button>
										<ul className="dropdown-menu dropdown-menu-right shadow-lg">
											<li className="px-4 pb-3 pt-3">
												<a className="font-weight-normal text-black">Edit</a>
											</li>
											<li className="px-4 pb-3">
												<a className="font-weight-normal text-black">Delete</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="task-category-body">
								<ul className="task-list">
									<li className="regular-14 gray_dark_01 mb-2 cursor-none">
										Need your sample review <span className="gray_dark_01">(20)</span>
									</li>
									<li className="regular-14 gray_dark_01 mb-2">
										Send to buyer <span className="gray_dark_01">(45)</span>
									</li>
									<li className="regular-14 gray_dark_01">
										Buyer sample review <span className="gray_dark_01">(23)</span>
									</li>
								</ul>
							</div>
							<div className="view-more d-flex align-items-center cursor-pointer mt-2">
								<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
									View <span>4</span> more
								</p>
								<CommonImage
									className="arrow-icon"
									src="/icons/down-arrow-gray-dark-01.svg"
									width={20}
									height={20}
								/>
							</div>
						</div>
						{/* Sample development Card */}
						<div className="task-category-card shadow-2dp">
							<div
								className="task-category-header d-flex align-items-center justify-content-between mb-3 p-1"
								style={{ backgroundColor: '#EFF6FF' }}
							>
								<div className="d-flex align-items-center">
									<CommonImage src="/icons/pom/t-shirt.svg" className="mr-2" />
									<p className="regular-14 weight-600" style={{ color: '#1C398E' }}>
										Sample development
									</p>
								</div>
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
										>
											<CommonImage
												src="/icons/more_vertical.svg"
												alt="more_icon"
												width={24}
												height={24}
											/>
										</button>
										<ul className="dropdown-menu dropdown-menu-right shadow-lg">
											<li className="px-4 pb-3 pt-3">
												<a className="font-weight-normal text-black">Edit</a>
											</li>
											<li className="px-4 pb-3">
												<a className="font-weight-normal text-black">Delete</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="task-category-body">
								<ul className="task-list">
									<li className="regular-14 gray_dark_01 mb-2 cursor-none">
										Need your sample review <span className="gray_dark_01">(20)</span>
									</li>
									<li className="regular-14 gray_dark_01 mb-2">
										Send to buyer <span className="gray_dark_01">(45)</span>
									</li>
									<li className="regular-14 gray_dark_01">
										Buyer sample review <span className="gray_dark_01">(23)</span>
									</li>
								</ul>
							</div>
							<div className="view-more d-flex align-items-center cursor-pointer mt-2">
								<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
									View <span>4</span> more
								</p>
								<CommonImage
									className="arrow-icon"
									src="/icons/down-arrow-gray-dark-01.svg"
									width={20}
									height={20}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TaskDashboardView;
